import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./SupplierQuotesOverviewPage.less');

const SupplierQuotesOverviewPage: FC<any> = ({
	history,
	match,
	childRoutes,
}): React.ReactElement => {
	const path = nullSafeGetOrElse('path', match, '/supplier/quotes');

	const handleTabChange = useCallback((key) => history.push(`${path}/${key}`), [history, path]);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
	];

	return (
		<>
			<Route
				path={`${path}`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `${path}/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Quotes"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="quotesPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierQuotesOverviewPage));
